import React, { useCallback, useMemo, useState } from 'react';
import { Attributes } from '@leverege/ui-attributes';
import Path from '@leverege/path';
import { OperatingHoursEditor, PluginSetup as UIOperatingHoursPluginSetup } from '@leverege/ui-operating-hours';
import { OperatingHours, PluginSetup as OperatingHoursPluginSetup } from '@leverege/operating-hours';
import { Content, PropertyGrid, Selector, Text } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import { useSelector, useDispatch, connect } from 'react-redux';
import { createSelector } from 'reselect';
import Util from "./Util.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = I18N.ns('molten.dataViewers.operatingHours.OperatingHoursView');
OperatingHoursPluginSetup.install(window.Molten);
UIOperatingHoursPluginSetup.install(window.Molten);
const getRolesSelector = createSelector(state => state.ui.personas, personas => personas);
function OperatingHoursView(props) {
  const {
    relationship,
    item,
    delegate,
    canUpdate
  } = props;
  const {
    blueprint
  } = relationship;
  const operatingHoursPaths = blueprint?.metadata?.operatingHours?.paths;
  const userRoles = useSelector(getRolesSelector);
  const editablePaths = useMemo(() => {
    return getEditablePaths(userRoles, operatingHoursPaths);
  }, [userRoles, operatingHoursPaths]);
  const dispatch = useDispatch();
  const [activePath, setActivePath] = useState(editablePaths?.[0]?.value);
  const onChange = useCallback(({
    data,
    value
  }) => {
    dispatch(delegate.update({
      header: [{
        path: `metadata/${activePath}`,
        value
      }]
    }));
  }, [delegate, activePath, dispatch]);
  const value = useMemo(() => {
    const operatingHours = Path.get(activePath, item?.metadata);
    if (operatingHours) {
      return operatingHours;
    }
    const position = Attributes.get('geoPosition', blueprint.type, item);
    const timezone = Util.getTimezoneForPosition(position);
    return OperatingHours.create({
      timezone
    });
  }, [activePath, item, blueprint.type]);
  return /*#__PURE__*/_jsxs(Content, {
    relative: true,
    children: [/*#__PURE__*/_jsx(Content.Header, {
      variant: "operatingHoursEditor",
      layout: "flex:colM",
      children: !operatingHoursPaths ? /*#__PURE__*/_jsx(Text, {
        children: t('notAvailableForBlueprint')
      }) : !editablePaths && !canUpdate ? /*#__PURE__*/_jsx(Text, {
        children: t('notAvailableForRole')
      }) : editablePaths.length > 1 && /*#__PURE__*/_jsx(PropertyGrid, {
        variant: "operatingHours",
        children: /*#__PURE__*/_jsx(PropertyGrid.Item, {
          label: t('selectOperatingHours'),
          children: /*#__PURE__*/_jsx(Selector, {
            value: activePath,
            values: editablePaths,
            onChange: ({
              value
            }) => setActivePath(value)
          })
        })
      })
    }), /*#__PURE__*/_jsx(Content.Area, {
      children: editablePaths && editablePaths.length > 0 && /*#__PURE__*/_jsx(OperatingHoursEditor, {
        value: value,
        onChange: onChange,
        blueprint: blueprint
      }, activePath)
    })]
  });
}
export default connect((state, props) => {
  const {
    delegate
  } = props;
  return {
    canUpdate: delegate.canUpdate()
  };
})(OperatingHoursView);
function getEditablePaths(userRoles, paths) {
  if (!userRoles || userRoles.length === 0 || !paths || paths.length === 0) {
    return null;
  }
  return paths.filter(path => {
    if (path.allowedRoles == null || path.allowedRoles === '*' || path.allowedRoles.includes('*')) {
      return true;
    }
    return userRoles.some(role => {
      return role.name === 'default' || role.metadata?.isAdmin === true || path.allowedRoles.includes(role.name);
    });
  });
}